'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var timeouts = {};
var timerID = 1; // In specification timer ID should be greater then 0

var isPromiseNative = typeof Promise !== 'undefined' && Promise.toString().includes('[native code]');

var setTimeoutWithZero = function setTimeoutWithZero(cb) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return setTimeout.apply(undefined, [cb, 0].concat(args));
};

var setImmediate = isPromiseNative ? function (cb) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  var fn = typeof cb !== 'function' ? new Function('' + cb) : cb;
  var currentTimerID = ++timerID;
  timeouts[currentTimerID] = fn;
  Promise.resolve().then(function (_) {
    return timeouts[currentTimerID] && (args.length ? fn.apply(undefined, args) : fn()) & clearImmediate(currentTimerID);
  });
  return currentTimerID;
} : setTimeoutWithZero;
var clearImmediate = isPromiseNative ? function (timerID) {
  return delete timeouts[timerID];
} : clearTimeout;
exports.default = setImmediate;
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;